<script>
  export default {
    name: 'BaseModal',
    components: {},
    props: {
      visible: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      show () {
        this.visible = true
      },
      hide () {
        this.visible = false
      },
      close () {
        this.visible = false
        this.$emit('close')
      }
    }
  }
</script>

<template>
  <Transition name="fade">
    <div
      @click.self="close"
      class="fixed inset-0 w-full h-screen z-50 flex items-center justify-center bg-semi-75"
      id="modal"
      v-if="visible"
    >
      <div class="relative w-full max-w-2xl bg-white shadow-lg rounded-lg p-8">
        <button
          @click.prevent="close"
          aria-label="close"
          class="absolute top-0 right-0 text-xl text-gray-500 my-2 mx-4"
        >
          ×
        </button>
        <slot/>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.4s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .bg-semi-75 {
    background-color: rgba(0, 0, 0, 0.75);
  }
</style>
